// src/pages/ContactUs.js
import React, { useState } from 'react';
import './ContactUs.css';

function ContactUs() {
  // State for contact form
  const [formResponse, setFormResponse] = useState('');
  const [contactFormData, setContactFormData] = useState({
    name: '',
    email: '',
    phone: '',
    smsConsent: false,
    message: ''
  });

  // Handle changes in the contact form fields
  const handleContactChange = (e) => {
    const { name, value, type, checked } = e.target;
    setContactFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Submit the contact form
  const handleContactSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('name', contactFormData.name);
    data.append('email', contactFormData.email);
    data.append('phone', contactFormData.phone);
    data.append('smsConsent', contactFormData.smsConsent);
    data.append('message', contactFormData.message);

    fetch('php/mail.php', {
      method: 'POST',
      body: data,
    })
      .then((response) => response.text())
      .then((responseText) => {
        setFormResponse(responseText);
        // Reset form
        setContactFormData({
          name: '',
          email: '',
          phone: '',
          smsConsent: false,
          message: '',
        });
      })
      .catch(() => {
        setFormResponse('There was an error submitting your message. Please try again.');
      });
  };

  return (
    <div className="contact-page">
      <main className="main-content">
        <h1>Contact Calimesa Turf Center & Graystone Construction</h1>
        <div className="company-info">
          <p><strong>Graystone Construction — Corporate Office</strong></p>
          <p>
            Office Location: 1590 Continental St. #206, San Diego, CA 92154
          </p>
          <p>
            Phone: <a href="tel:+16197611113">+1 (619) 761‑1113</a>
          </p>
          <div className="quick-actions" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
            <a className="qa-btn" href="tel:+16197611113" aria-label="Call Saint Jude’s Medical Center 24/7">Call 24/7</a>
            <a className="qa-btn secondary" href="https://maps.google.com/?q=1590%20Continental%20St%20%23206%2C%20San%20Diego%2C%20CA%2092154" target="_blank" rel="noopener noreferrer" aria-label="Get directions to Saint Jude’s Medical Center">Get Directions</a>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleContactSubmit}>
          <label htmlFor="name">Your Name</label>
          <input
            id="name"
            name="name"
            placeholder="Your Name"
            required
            value={contactFormData.name}
            onChange={handleContactChange}
          />

          <label htmlFor="email">Your Email</label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="Your Email"
            required
            value={contactFormData.email}
            onChange={handleContactChange}
          />

          <label htmlFor="phone">Phone Number</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            placeholder="Your Phone Number"
            required
            value={contactFormData.phone}
            onChange={handleContactChange}
            inputMode="tel"
          />

          <div className="checkbox-group">
            <input
              id="smsConsent"
              name="smsConsent"
              type="checkbox"
              checked={contactFormData.smsConsent}
              onChange={handleContactChange}
            />
            <label htmlFor="smsConsent" className="checkbox-label">
              By checking this box, you agree to receive SMS text messages from Graystone Construction & Calimesa Turf Center regarding your request. Reply STOP to opt out at any time. Reply HELP for customer care contact information. Messages and data rates may apply. Message frequency may vary. See our{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" className="footer-link">Privacy Policy</a>{' '}and{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer" className="footer-link">Terms and Conditions</a>.
            </label>
          </div>

          <label htmlFor="message">Your Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Write your message here..."
            rows="5"
            required
            value={contactFormData.message}
            onChange={handleContactChange}
            aria-label="Your Message"
          ></textarea>

          <button type="submit" className="send-btn">
            Send Message
          </button>
        </form>

        {formResponse && <div className="form-response">{formResponse}</div>}
      </main>
    </div>
  );
}

export default ContactUs;